export enum PolycomExpansionModel {
  'polycom-vvx-color' = 'Polycom VVX Color',
  'polycom-vvx-em' = 'Polycom VVX EM',
  'polycom-vvx-em50' = 'Polycom VVX EM50',
}

export type PolycomExpansionModelCode = keyof typeof PolycomExpansionModel;
